import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";

interface registrationState {
  eventRegistrationRes: {};
  httpError: {};
  status: string;
  markAttendance: {};
}

const initialState: registrationState = {
  eventRegistrationRes: {},
  httpError: {},
  status: "",
  markAttendance: {},
};

const registrationSlice = createSlice({
  name: "eventRegistration",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(registerForEvent.fulfilled, (state, action) => {
        state.eventRegistrationRes = action.payload;
        state.status = "success";
      })
      .addCase(registerForEvent.rejected, (state, action) => {
        const payload: any = action.payload;
        state.httpError = payload.response;
        state.status = "error";
      })
      .addCase(updateAttendance.fulfilled, (state, action) => {
        state.markAttendance = action.payload;
        state.status = "success";
      })
      .addCase(updateAttendance.rejected, (state, action) => {
        const payload: any = action.payload;
        state.httpError = payload?.response;
        state.status = "error";
      })
      .addCase(spotRegister.fulfilled, (state, action) => {
        state.eventRegistrationRes = action.payload;
        state.status = "success";
      })
      .addCase(spotRegister.rejected, (state, action) => {
        const payload: any = action.payload;
        state.httpError = payload?.response;
        state.status = "error";
      });
  },
});

export default registrationSlice.reducer;

export const registerForEvent = createAsyncThunk(
  "/create-eventRegistration",
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `api/eventregistration/create-eventRegistration`,
        data
      );
      return response.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

export const updateAttendance = createAsyncThunk(
  "events/changeAttendance",
  async (payload: any) => {
    const response = await axiosInstance.put(
      `api/events/changeAttendance`,
      payload
    );
    return response.data;
  }
);

export const spotRegister = createAsyncThunk(
  "spot-register",
  async (
    data: { shortId: string; eventId: number; eventSlotId: number },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosInstance.post(`api/eventregistration/spot-register`, data);
      return response.data;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);
